<template>
  <div class="mainpage flex justify-center"  :style="main_style">
    <main v-if="post_detail" >

      <div>
      <section class="congrats">
        <h3 :style="congrats_style" class="m-0">Congratulations</h3>
        <!--
        <div :style="congrats_style" class="won">You have won</div>
        <h3 :style="congrats_style">{{post_detail.award_name}}!</h3>
        -->
        <div class="confirmation-code">
          <div class="check-email"><i>Please check your e-mail to see your reward code.</i></div>
          <h1>CNF#:<span class="prize-code">RANDOM</span></h1>
        </div>
      </section>

      <section class="congrats">
        <h3 :style="congrats_style" class="m-0"><strong>TO PLAY THE GAME</strong></h3>
        <img class="congrats-img" src="../assets/images/Scratch_Win_Vector.png" />
        <h4 :style="congrats_style" :class="post_detail.interaction.is_played ? 'disabled' : ''"
              @click.prevent="submitForm" >
           <strong>{{ !post_detail.interaction.is_played ? 'Please check your Email' : 'Already Played' }}</strong></h4>
      </section>

      <social-links :post_detail="post_detail" />
      </div>
    </main>
  </div>
</template>
<script>
import VueScratchable from 'vue-scratchable'
import ScratchSurface from './pages/components/ScratchSurface'
import SocialLinks from './SocialLinks'
export default {
  props: {
    slug: String
  },
  data () {
    return {
      prizeItem: null,
      fieldnames: [
        {
          name: 'Name',
          code: 'name',
          value: false
        },
        {
          name: 'Phone Number',
          code: 'phone',
          value: false
        },
        {
          name: 'Email',
          code: 'email',
          value: false
        },
        {
          name: 'Birthday',
          code: 'birthday',
          value: false
        },
        {
          name: 'Address',
          code: 'address',
          value: false
        }
      ],
      name: '',
      email: '',
      birthday: '',
      phone: '',
      address: '',
      showPrize: false,
      setupTime: new Date().getTime().toString(),
      nowTime: new Date().getTime(),
      sessiomInterval: null,
      sessionid: (localStorage.getItem('sessionid') && localStorage.getItem('sessionid') !== 'undefined') ? localStorage.getItem('sessionid') : this.makeid(25),

      post_detail: null
    }
  },
  components: {
    VueScratchable,
    ScratchSurface,
    SocialLinks
  },
  mounted () {
    if (this.slug) {
      this.getCard()
    }
  },
  destroyed () {
  },
  watch: {
  },
  computed: {

    main_style () {
      if (this.campaign_theme) {
        if (this.isObject(this.campaign_theme.main)) {
          return `background: url(${this.getImage(this.campaign_theme.main.url)})`
        } else if (this.campaign_theme.main !== '') {
          return `background: ${this.campaign_theme.main}`
        }
      }
      return ''
    },
    campaign_theme () {
      return this.$store.state.campaign_theme
    },
    congrats_style () {
      if (this.campaign_theme) {
        if (this.campaign_theme.congrats) {
          return `color: ${this.campaign_theme.congrats.color}; font-size: ${this.campaign_theme.congrats.size}px; font-weight: ${this.campaign_theme.congrats.weight};`
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    timeDiff () {

      let msec = this.nowTime - this.setupTime
      const hh = Math.floor(msec / 1000 / 60 / 60)
      msec -= hh * 1000 * 60 * 60
      const mm = Math.floor(msec / 1000 / 60)
      msec -= mm * 1000 * 60
      const ss = Math.floor(msec / 1000)
      msec -= ss * 1000

      return `${hh}:${mm}:${ss}`

      //return msec
    }
  },
  methods: {

    getImage (url) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${url}`
    },
    isObject (a) {
      return (!!a) && (a.constructor === Object)
    },
    makeid (length) {
      let result = ''
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
      const charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    open_link (url) {
      window.open(url, '_blank')
    },
    submitForm () {
      //const routeData = this.$router.resolve(`/scratch/game/${this.slug}`)
      //window.open(routeData.href, '_blank')
    },
    checkSessionValid () {
      this.nowTime = new Date().getTime()
      let msec = this.nowTime - this.setupTime
      const hh = Math.floor(msec / 1000 / 60 / 60)
      msec -= hh * 1000 * 60 * 60
      const mm = Math.floor(msec / 1000 / 60)
      msec -= mm * 1000 * 60
      const ss = Math.floor(msec / 1000)
      msec -= ss * 1000

      if (hh === 0 && mm >= 30) {
        this.refreshSession()
      }

      if (!this.sessiomInterval) {
        this.sessiomInterval = setInterval(this.checkSessionValid, 1000 * 60)
      }

    },
    refreshSession () {
      console.log('refresing session')

      localStorage.removeItem('prize')
      localStorage.removeItem('session')
      localStorage.removeItem('setup')

      location.reload()
    },
    setupData () {

      this.prizeItem = this.post_detail.prizeList[Math.floor(Math.random() * this.post_detail.prizeList.length)]
      if (!localStorage.getItem('sessionid') || localStorage.getItem('sessionid') === 'undefined') {
        console.log('no session')
        localStorage.setItem('sessionid', this.sessionid)
        localStorage.setItem('prize', JSON.stringify(this.prizeItem))
        localStorage.setItem('setup', new Date().getTime().toString())
      } else {
        console.log('has session')
        if (localStorage.getItem('prize') && localStorage.getItem('prize') !== 'undefined') {
          this.prizeItem = JSON.parse(localStorage.getItem('prize'))
        }
        if (localStorage.getItem('setup') && localStorage.getItem('setup') !== 'undefined') {
          this.setupTime = new Date(parseInt(localStorage.getItem('setup'))).getTime()
        } else {
          localStorage.setItem('setup', new Date().getTime().toString())
        }
      }

      const { campaign_theme } = JSON.parse(JSON.stringify(this.post_detail))

      this.$store.commit('SET_CAMPAIGN_THEME', campaign_theme)

      this.checkSessionValid()
    },
    getdataImg (id) {
      return `https://restapi.authorizelocal.com/api/posts/photo/${id}`
    },
    getCard () {
      const payload = {
        code: this.slug
      }
      this.$store.dispatch('getInteraction', payload)
        .then((response) => {
          console.log('success')
          console.log(response)
          this.post_detail = response.data.data
          this.setupData()
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error')
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss">
.prize-code {
  filter: blur(8px);
  -webkit-filter: blur(8px);
}
@media (max-width:768px){
  section, .congrats{
    padding:0;
  }
}
</style>
